import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const changeLanguage = (lng) => {
    // Update i18n language
    i18n.changeLanguage(lng);

    // Update URL with new language query parameter
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('lang', lng);

    // Navigate to same page with updated query parameter
    navigate(`${location.pathname}?${searchParams.toString()}${location.hash}`, { replace: true });
  };

  const currentLanguage = i18n.language || 'en';

  return (
    <div className="flex items-center gap-1 bg-gray-100 rounded-md p-0.5">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-2 py-1 rounded text-xs font-medium transition-all ${
          currentLanguage === 'en' || currentLanguage.startsWith('en')
            ? 'bg-blue-600 text-white shadow-sm'
            : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
        }`}
        title="English"
      >
        EN
      </button>
      <button
        onClick={() => changeLanguage('fr')}
        className={`px-2 py-1 rounded text-xs font-medium transition-all ${
          currentLanguage === 'fr' || currentLanguage.startsWith('fr')
            ? 'bg-blue-600 text-white shadow-sm'
            : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
        }`}
        title="Français"
      >
        FR
      </button>
    </div>
  );
};

export default LanguageSwitcher;
